export default {

  /*
  * Auth actions
  */

  saveUserToken: (state, token) => {
    sessionStorage.setItem('user-token', token)
    sessionStorage.setItem('user-token-created-at',  Date.now())
    state.token = token
  },
  destroyUserToken: (state) => {
    sessionStorage.removeItem('user-token');
    state.token = ''
  },

  saveUserData: (state, data) => {
    state.user = data
  },
  destroyUserData: (state) => {
    state.user = {}
  },

  /*
  * Login actions
  */

  saveLoginData: (state, data) => {
    state.login = data
  },
  destroyLoginData: (state) => {
    state.login = {}
  },

  /*
  * Register
  */

  saveRegisterData: (state, data) => {
    state.register = data
  },
  destroyRegisterData: (state) => {
    state.register = {}
  },

  /*
  * Medical Case actions
  */

  // save data from first step of 'create medical case'
  updatePatientData: (state, data) => {
    state.report.patientData = data;
  },
  // save data from second step of 'create medical case'
  updateMedicalData: (state, data) => {
    state.report.medicalData = data;
  },
  // save data from third step of 'create medical case'
  updateFindings: (state, data) => {
    state.report.findings = data;
  },
  // save attachments count and dir name
  updateAttachments: (state, data) => {
    state.report.attachments = data;
  },

  /**
   * Medical Case List
   */

  // save current case
  saveReportListData: (state, data) => {
    state.reportList = data;
  },

  /**
   * Medical Case Table
   */

  // save current case
  saveReportTableData: (state, data) => {
    state.reportTable = data;
  }
}
